/**
 * Analytics utility for GTM dataLayer event tracking.
 *
 * All events are pushed to window.dataLayer which GTM picks up.
 * Configure GTM tags in the GTM web UI to forward events to GA4,
 * set up conversions, and build funnels.
 */

function push(event, params = {}) {
  if (window.dataLayer) {
    window.dataLayer.push({ event, ...params });
  }
}

// ── Auth Events ──────────────────────────────────────────────

export function trackSignUp({ method = 'email', referral = false, businessLinked = false }) {
  push('sign_up', { method, referral, business_linked: businessLinked });
}

export function trackLogin({ method = 'email' }) {
  push('login', { method });
}

export function trackLogout() {
  push('logout');
}

// ── Deal Events ──────────────────────────────────────────────

export function trackDealClaim({ dealId, dealTitle, businessId, businessName }) {
  push('deal_claim', { deal_id: dealId, deal_title: dealTitle, business_id: businessId, business_name: businessName });
}

export function trackDealRedeem({ businessName, offer, success }) {
  push('deal_redeem', { business_name: businessName, offer, success });
}

export function trackInstantRedeem({ businessId, success }) {
  push('instant_redeem', { business_id: businessId, success });
}

// ── QR / Hub Events ─────────────────────────────────────────

export function trackQRScan({ hubId, referralSource }) {
  push('qr_scan', { hub_id: hubId, referral_source: referralSource });
}

export function trackHubUnlock({ hubId, hubName }) {
  push('hub_unlock', { hub_id: hubId, hub_name: hubName });
}

// ── Payment Events ──────────────────────────────────────────

export function trackBeginCheckout({ planTier, billingPeriod }) {
  push('begin_checkout', { plan_tier: planTier, billing_period: billingPeriod });
}

export function trackPurchase({ planTier }) {
  push('purchase', { plan_tier: planTier });
}

export function trackPlanSelected({ planTier }) {
  push('plan_selected', { plan_tier: planTier });
}

// ── Onboarding Events ───────────────────────────────────────

export function trackOnboardingStep({ step, stepName }) {
  push('onboarding_step', { step, step_name: stepName });
}

export function trackOnboardingComplete({ isTrial }) {
  push('onboarding_complete', { is_trial: isTrial });
}

// ── Engagement Events ───────────────────────────────────────

export function trackDealCreate({ dealTitle, generateLead }) {
  push('deal_create', { deal_title: dealTitle, generate_lead: generateLead });
}

export function trackDealEdit({ dealId }) {
  push('deal_edit', { deal_id: dealId });
}

export function trackNewsletterSignup() {
  push('newsletter_signup');
}

export function trackHubApplication({ venueName }) {
  push('hub_application', { venue_name: venueName });
}

export function trackProfileUpdate() {
  push('profile_update');
}

// ── User Identity ───────────────────────────────────────────

export function setUserProperties({ userId, role, subscriptionTier }) {
  push('set_user_properties', { user_id: userId, user_role: role, subscription_tier: subscriptionTier });
}
